import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal/index';
import { Row } from "react-flexa";
import {
    BannerContainer,
    OvalBackground,
    BannerImageWrapper,
    BannerWrapper,
    PointerImage,
    BannerImageUSP
} from './Components';
import ProductList from '../ProductList/index';
import { ModalContainer, ModalWrapper } from '../common/Modal/Component';
import { Image, ImageContainer } from '../common/ui/Image';
import CutomButton from '../common/ui/CutomButton'
import Heading from '../common/ui/Heading';
import Text from '../common/ui/Text';
import { onButtonClick } from '../../utils/helpers';

const Pointers = ({ data }) => {
  const {
    description,
    icon={src: '', width:'', sWidth:''}
  } = data;

  return (
    <div>
      <ImageContainer
        width={icon.width || "35px"}
        sWidth={icon.sWidth || "24px"}
        sHeight="26px"
        height='36px'
        sdisplay="inline-block"
      >
        <Image
          src={icon.src}
        />
      </ImageContainer>
      <Text
        widthm="80%"
        opacity='0.8'
        size='xxxl'
        weight='medium'
        lineHeight='1.3'
        margin="0px 0px 30px"
        color='BLACK'
        align="left"
        sWidth="100%"
        display="inline-flex"
        sPadding="0px 0px 0px 15px"
        padding="12px 0px 0px 0px"
      >
        {description}
      </Text>
    </div>
  )
}

/**
* Banner component
*
*/
const Banner = ({ bannerData, productsList }) => {
  const [ toggleModal, setToggleModal ] = useState(false);
  const [ top, setTop ] = useState(null);
  const [ left, setLeft ] = useState(null);

  useEffect(() => {
    if (toggleModal) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [toggleModal]);

  const modalHandler = (name, e) => {
      e.stopPropagation();
      if(e.target.getAttribute("class").split(" ").includes("Back") === false){
        setToggleModal(!toggleModal);
        if(toggleModal == false){
          let element = document.getElementById(name).getBoundingClientRect();
          setTop(element.top+'px');
          setLeft(element.left+'px');
        }
      }
  }

  return (
      <BannerContainer
        background={`url(${bannerData.firstBackgroundImgSrc}) no-repeat center top`}
        backgroundAfter={`url(${bannerData.secondBackgroundImgSrc}) no-repeat`}
        sBackground={`url(${bannerData.mobileBackgroundImgSrc})`}
        sTop={`${bannerData.mobileImageTop}`}
        sRight={`${bannerData.mobileImageRight}`}
        sWidth={`${bannerData.mobileImageWidth}`}
        sBackgroundSize={`${bannerData.mobileImageBackgroundSize}`}
        sTransform={`${bannerData.mobileImageTransform}`}
        sHeight={`${bannerData.mobileImageHeight}`}
      >
        <BannerWrapper
          sMargin="-20px auto 50px"
        >
          <OvalBackground
            diameter="700px"
            top='-239px'
            left='-350px'
            opacity="1"
            mTop="-160px"
            mLeft="-240px"
            sTop="-120px"
            sLeft="-100px"
            sDiameter="250px"
            mDiameter="500px"
          />
          <Row
            flexDirection="column"
            style={{ flex:"0.8" }}
          >
            <CutomButton
              minwidth="max-content"
              swidth="116px"
              width="131px"
              backgroundcolor="WHITE"
              color="CHQBOOK_BLUE"
              weight="bold"
              opacity="0.9"
              size="xxl"
              margin="40px 0px 0px"
              mmargin="0px"
              border="1px solid rgba(20, 70, 125, 0.2)"
              hovercolor="primary"
              boxshadow="0 4px 8px 0 rgba(0, 0, 0, 0.05)"
              hoverbackground="WHITE"
              onClick={modalHandler.bind(null, "modal")}
              smargin="40px auto 0px"
              padding="0px 12px"
              letterspacing="0.26px"
              borderradius="6px"
              id="modal"
            >
              {bannerData.bannerName}
              <Image
                src={`${bannerData.bannerModalArrowImgSrc}`}
                width="11px"
                style={{ margin:"0px 0px 0px 11px" }}
              />
            </CutomButton>
            <Modal
              show={toggleModal}
              modalClosed={modalHandler.bind(null, null)}
            >
            <ModalContainer
              top={top}
              left={left}
              sTop="111px"
              sLeft="50%"
              sTransform="translate(-50%, 0%)"
              transform="translate(0px, 0px)"
              className="Back"
            >
              <CutomButton
                width="max-content"
                backgroundcolor="WHITE"
                color="CHQBOOK_BLUE"
                size="xxl"
                weight="bold"
                hoverbackground="WHITE"
                border="none"
                hovercolor="primary"
                onClick={modalHandler.bind(null, null)}
                padding="2px 10px"
                height="auto"
              >
              {bannerData.bannerName}&nbsp;
              <Image
                src={`${bannerData.bannerModalArrowImgSrc}`}
                width="12px"
                style={{ transform:"rotate(180deg)" }}
              />
            </CutomButton>
              <ModalWrapper className="Back">
                <ProductList
                  textstyle={{
                    margin:"0px",
                    padding:"15px 0px 0px",
                    height:'100%'
                  }}
                  listcard = {{
                    border: "1px solid rgba(128, 128, 128, 0.1)",
                    height: "100%",
                    padding: "15px 0px",
                    align: "center",
                    width: "158px",
                    sWidth:"104px",
                    cursor:"pointer",
                    minHeight:"96px",
                    sMinHeight:"110px",
                    sPadding:"15px 5px"
                  }}
                  data={productsList.productLists}
                />
                </ModalWrapper>
              </ModalContainer>
            </Modal>
            <Heading
              color='MEDIUM_BLACK'
              maxWidth='max-content'
              size='lg'
              weight='normal'
              lineHeight='1.37'
              margin="25px 10px 25px 0px"
              sMargin="20px auto"
              padding="0px 10px 0px 0px"
              sPadding="0px"
            >
              {bannerData.bannerHeading}
              <ImageContainer
                width="210px"
                sWidth="180px"
                margin="-20px 0px 0px 0px"
                sMargin="-10px auto 0px auto"
                xsMargin="-10px auto 0px auto"
                sdisplay="block"
              >
                <Image
                  src={`${bannerData.bannerHeadingBottomRedLineImgSrc}`}
                />
              </ImageContainer>
            </Heading>
            <Text
              color='MEDIUM_BLACK'
              opacity='0.7'
              size='xl'
              weight='medium'
              lineHeight='1.7'
              letterSpacing='-0.33px'
              width="438px"
              margin="0px 0px 30px"
              sMargin="0px auto"
              padding="0px 5vw 0px 0px"
              sPadding="0px"
            >
              {bannerData.bannerDescription}
            </Text>
            {/* {bannerData.poweredBy && <ImageContainer
              sPadding="30px 0px 0px"
            >
              <Text
                display="inline-block"
                weight="large"
                color="MEDIUM_GREY"
              >
              {bannerData.poweredBy}
              </Text>
              <Image src={bannerData.poweredByBankLogo} width="147px" style={{ marginLeft:"10px" }}/>
            </ImageContainer>} */}
              <CutomButton
                sdisplay="none"
                size="md"
                weight="bold"
                height="40px"
                margin="30px 0px 0px"
                width="max-content"
                maxwidth="320px"
                minwidth="230px"
                boxshadow="0 4px 8px 1px rgba(0, 0, 0, 0.08)"
                lineheight='2'
                letterspacing='0.62px'
                padding="1px 15px"
                onClick={onButtonClick.bind(null, bannerData.link, bannerData.external)}
              >
                  {bannerData.bannerAppDownloadDesktopView.content}
                  {bannerData.bannerAppDownloadDesktopView.androidImgSrc && <ImageContainer
                    width='13px'
                    margin="-4px 5px 0px"
                  >
                      <Image
                        src={`${bannerData.bannerAppDownloadDesktopView.androidImgSrc}`}
                      />
                  </ImageContainer>}
                  {bannerData.bannerAppDownloadDesktopView.iosImgSrc && <ImageContainer
                    width='13px'
                    margin="-4px 5px 0px"
                  >
                    <Image
                      src={`${bannerData.bannerAppDownloadDesktopView.iosImgSrc}`}
                    />
                  </ImageContainer>}
              </CutomButton>
          </Row>
          <BannerImageUSP>
            <BannerImageWrapper
              xxlMargin="0px 30px 0px 0px"
              margin="0px 30px 0px 0px"
            >
              <ImageContainer
                width="253px"
                height='auto'
              >
                  <Image src={`${bannerData.bannerImageSrc.img}`} alt={`${bannerData.bannerImageSrc.alt || "Chqbook"}`}/>
              </ImageContainer>
            </BannerImageWrapper>
            <PointerImage>
              { bannerData.bannerPointersList.map((el, i) => (
                  <Pointers
                    key={i}
                    data={el}
                  />
              )) }
            </PointerImage>
          </BannerImageUSP>
            <CutomButton
                size="xl"
                weight="bold"
                width="max-content"
                backgroundcolor="white"
                color="CHQBOOK_BLUE"
                border="1px solid rgba(25, 68, 122, 0.2)"
                hovercolor="blue"
                hoverbackground="WHITE"
                boxshadow="0 11px 22px 0 rgba(0, 0, 0, 0.1)"
                borderradius="5px"
                height="46px"
                minwidth="230px"
                padding="7px 8px 12px"
                margin="20px auto 0px"
                smargin="0px auto 0px"
                display="none"
                sdisplay="block"
                onClick={onButtonClick.bind(null, bannerData.link, bannerData.external)}
              >
                {bannerData.bannerAppDownloadMobileView.content}&nbsp;
                {bannerData.bannerAppDownloadMobileView.androidImgSrc && <ImageContainer
                  width='15px'
                  margin="-5px 0 0px"
                >
                    <Image
                      src={`${bannerData.bannerAppDownloadMobileView.androidImgSrc}`}
                    />
                </ImageContainer>}&nbsp;
                {bannerData.bannerAppDownloadMobileView.iosImgSrc && <ImageContainer
                  width='16px'
                  margin="-7px 5px 0px 5px"
                >
                  <Image
                    src={`${bannerData.bannerAppDownloadMobileView.iosImgSrc}`}
                  />
                </ImageContainer>}
              </CutomButton>
        </BannerWrapper>
    </BannerContainer>)
}

export default Banner;
